import { Loc } from "./location";

// Change me based on the information received on first skiing day
export const start = new Loc(-79.992145, -79.584587, 130);
export const sp = new Loc(-90.0, 90.0, 2830);
